module.exports = __webpack_public_path__ + "static/media/binoculars.dfa34220.svg";